/* eslint-disable camelcase */
import $ from 'jquery';
import {
  AutoScroll, Sortable, Swap,
} from 'sortablejs/modular/sortable.core.esm';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _t from '../../utils/translate';
import templateHead from './templates/head';
import templateNonePlayer from './templates/none-player';
import templateFreePlayer from './templates/free-players';
import templateTable from './templates/table';
import createManager from '../../utils/createManager';
import createTeam from '../../utils/createTeam';
import showAlert from '../../utils/showAlert';
import Swiper from 'swiper';
import '@fancyapps/fancybox';
import introJs from 'intro.js';

import {
  getToken,
  login,
} from '../../utils/login.js';

import {
  block,
  unblock,
} from '../../utils/blocker';

import {
  addTeamPlayer,
  changePosition,
  createMatch,
  claimYoungPlayers,
  getFreePlayers,
  getTeamInfo,
  removeTeamPlayer,
  saveSettings,
} from '../../utils/api';
import { isLoginRequired } from "../../utils/isLoginRequired";

Sortable.mount(new Swap(), new AutoScroll());

const $target = $('#js-my-team');

const render = async () => {
  const token = getToken();

  const { owner, team, positions, substitutes, manager, matchSeo, formations } = await getTeamInfo({
    data: {
      token,
    },
  });

  if (!manager) {
    await createManager();
  }
  if (!substitutes) {
    //TODO Tekin
  }

  $target.html(`
    ${templateHead({ team, owner, manager, matchSeo })}
    ${team.id ? templateTable({ team, positions, manager, substitutes, formations }) : templateNonePlayer()}
  `);

  if (document.getElementById('js-swap-table')) {
    new Sortable(document.getElementById('js-swap-table'), {
      handle: '.my-team__handle', // handle's class
      animation: 150,
      filter: '.filtered', // 'filtered' class is not draggable
      swap: true,
      swapClass: 'highlighted',
      // Element dragging ended
      onEnd: async (/** Event */evt) => {
        console.log(evt.swapItem);
        console.log(evt.item);
        const nft_id = $(evt.item).data('nft_id');
        const order_no = $(evt.swapItem).data('order_no');
        const exist_nft_id = $(evt.swapItem).data('nft_id');
        const position_id = $(evt.swapItem).data('position_id');
        if (!exist_nft_id) {
          $(evt.swapItem).remove();
        }
        const res = await changePosition({
          data: {
            token,
            nft_id,
            exist_nft_id,
            position_id,
            order_no,
          },
        });

        render();
      },

    });
  }

  $('select#formation').on('change', (e) => {
    document.location.reload();
  });
};

const myTeam = async () => {

  if ($target.length === 0) {
    return false;
  }

  if (isLoginRequired()){
    return;
  }

  // if (!await checkMetamask()) {
  //   return;
  // }
  //
  // if (!await login()) {
  //   return;
  // }

  await render();

  const token = getToken();

  const intro = introJs();

  intro.setOptions({
    // disableInteraction: true,
    dontShowAgain: true,
    steps: [
    //   {
    //     title: 'Welcome Game DashBoard',
    //     element: document.querySelector('.i-dashboard'),
    //     intro: 'This is Game Dashboard'
    //   },
    //   {
    //     title: 'Market',
    //     element: document.querySelector('.i-market'),
    //     intro: 'You can be buy shoes, forms and nfts and items'
    //   },
    //   {
    //     title: 'Tournaments',
    //     element: document.querySelector('.i-tournaments'),
    //     intro: 'You can be join Tournaments'
    //   },
    //   {
    //     title: 'Notification',
    //     element: document.querySelector('.i-notf'),
    //     intro: 'You can be look your Notification on Training'
    //   },
    //   {
    //     title: 'Event',
    //     element: document.querySelector('.i-event'),
    //     intro: 'See your Events'
    //   },
      {
      title: 'Welcome',
      intro: 'Hey Manager 👋 This is your team page. Here you can see your team players, formation and tactics. You can also create a match and invite your friends to play with you.'
    },
      {
        title: 'Team Overview',
        element: document.querySelector('.myteam__section'),
        intro: 'You can see your team players, formation and tactics here.'
      },
      {
        title: 'Tactics',
        element: document.querySelector('.team__info'),
        intro: 'You can change the formation of your team by dragging and dropping the players.'
      },
      {
        title: 'Positions',
        element: document.querySelector('.team__list'),
        intro: 'See the players overall stats and their positions. You can add or remove players from your team by clicking on the buttons.'
      },
      {
        title: 'Team Captain',
        element: document.querySelector('.team-captain'),
        intro: 'Who will be the team captain?'
      },
      {
        title: 'Freekick Taker',
        element: document.querySelector('.freekick-player'),
        intro: 'Who will take the freekicks?'
      },
      {
        title: 'Create A Match',
        element: document.querySelector('.js-create-match'),
        intro: 'Let\'s create a match and invite your friends to play with you.'
      },

    ]

  }).start();

  // team
  $(() => {
    $(document).off('click.js-remove-team-player').on('click.remove-team-player', '.js-remove-team-player', async (e) => {
      const $that = $(e.currentTarget);

      if ($that.data('nft_id')) {
        const { success, message, nft } = await removeTeamPlayer({
          data: {
            token,
            nft_id: $that.data('nft_id'),
            generation: $that.data('generation'),
          },
        });

        if (success) {
          $that.parents('.my-team__row-item').attr('data-nft_id', '');
          $that.parents('.my-team__row-item').find('.my-team__player-bg img').attr('src', '');
          $that.parents('.my-team__row-item').find('span').text('Empty');

          $('.player-list').prepend(`
            <div class="player-list__item js-add-to-team" data-nft_id="${nft.id}" data-rarity="${nft.rarity}">
              <div class="player-list__avatar">
                <div class="player-image">
                  <img src="${nft.image}" />
                </div>
                <button class="btn btn-addteam">Add team</button>
              </div>
              <span class="player-list__label">
                ${nft.name}
                <br/>
                ${nft.rarity}
                <br />
                ${nft.positions.join(', ')}
              </span>
            </div>
          `);

          showAlert({ message, icon: 'success' });

          render();
        } else {
          showAlert({ message, icon: 'error' });
        }
      }
    });

    createTeam();

    $(() => {
      $(document).on('click', '.js-create-match', async (e) => {
        const $that = $(e.currentTarget);
        const matchType = $that.data('type');

        if (matchType === 'death') {

          if (!await login()) {
            return;
          }

          Swal.fire({
            title: _t('Set The Price'),
            html: `<p style="margin-top: 85px" class="text-left">${_t(`You're creating a ${matchType} match. You need to specify $NFSGX amount for the match. Your opponent will participate in the match with the same amount. All tokens will be transferred and locked. The winner of the match will get all tokens.`)}</p>`,
            input: 'number',
            inputValidator: result => !result && _t('You need to enter value'),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: _t('Sure!'),
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              const { success, message, seo } = await createMatch({
                data: {
                  token,
                  type: matchType,
                  price: result.value,
                },
              });

              if (success) {
                showAlert({ message, icon: 'success' });
                window.location = seo;
              } else {
                showAlert({ message, icon: 'error' });
              }
            }
          });
        } else {
          Swal.fire({
            title: _t('Match Create!'),
            html: `<p style="margin-top: 90px" class="text-left">${_t(`You're creating a ${matchType} match. The cost of creating a friendly match is currently free. You can try your formation and tactics with friendly matches. Friendly matches does not have a reward.`)}</p>`,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: _t('Sure!'),
            showLoaderOnConfirm: true,
            // allowOutsideClick: () => !Swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              const { message, success, seo } = await createMatch({
                data: {
                  type: matchType,
                  token,
                },
              });
              if (success) {
                showAlert({ message, icon: 'success' });
                window.location.href = seo;
              } else {
                showAlert({ message, icon: 'error' });
              }
            }
          });
        }
      });

      $(document).on('click', '.js-claim-young-players', async (e) => {
        const $that = $(e.currentTarget);
        const formationId = $that.data('formation-id');
        Swal.fire({
          title: _t('Young Players'),
          html: `<p style="margin-top: 90px" class="text-left">${_t(`If you have the right to request young players, the system will automatically generate 11 players for you. All of the players will be spawned with random abilities based on the positions in your current team formation..`)}</p>`,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: _t('Sure!'),
          showLoaderOnConfirm: true,
          // allowOutsideClick: () => !Swal.isLoading(),
        }).then(async (result) => {
          block();
          if (result.isConfirmed) {
            const { message, success } = await claimYoungPlayers({
              data: {
                token,
                formationId: formationId,
              },
            });
            if (success) {
              unblock();
              showAlert({ message, icon: 'success' });
              document.location.reload();
            } else {
              unblock();
              showAlert({ message, icon: 'error' });
            }
          } else {
            unblock();
          }
        });
      });
    });

    let logoId = '';

    const showLogos = ({ title, html, icon = 'success', option = {} }, callbak = () => {}) => {
      let options = {
        showCancelButton: false,
        confirmButtonText: 'Save',
        customClass: {
          cancelButton: 'order-1',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
        title,
        html,
        onOpen() {
          $(document).off('change.js-profile-image').on('change.js-profile-image', '.js-profile-image', () => {
            logoId = $('[name="profile-image"]:checked').val();
            console.log(logoId);
          });
          const swiper = new Swiper('.js-swiper-logos', {
            spaceBetween: 10,
            allowTouchMove: false,
            slidesPerView: 3,
            navigation: {
              prevEl: $('.js-prev').get(0),
              nextEl: $('.js-next').get(0),
            },
            // navigation: {
            //   prevEl: $('.js-control-up'),
            //   nextEl: $('.js-control-down'),
            // },
            // freeMode: true,
            // freeModeSticky: true
          });
        },
      };

      options = Object.assign({}, options, option);

      Swal.fire(options).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        callbak(result)
      });

      // networkCheck();

      // $.post('/api/avatar/log', { m: message, e: 'a', mm: '0' });
    };

    $(document).on('click', '.js-open-logos', async () => {

      const res = await fetch('/api/team/getLogo', {}).then((res) => res.json());
      console.log(res)
      var newImages = `
      <div class="" style="position: relative;">
      <div class="swiper js-swiper-logos" style="width: 300px;">
                <div class="swiper-wrapper">
      `;
      const logos = Object.values(res.logos);
      for (let i = 0; i <= logos.length; i++) {
        newImages += `
          <div class="swiper-slide">
          <input name="profile-image" class="js-profile-image" type="radio" id="profile-image-${logos[i]?.id}" value="${logos[i]?.id}" />
          <label for="profile-image-${logos[i]?.id}">
            <img height="50px;" src="${logos[i]?.image}" alt="logo" />
          </label>
          </div>
        `;
      }

      newImages += `
        </div>
      </div>

      <div class="js-next swiper-button-next"></div>
      <div class="js-prev swiper-button-prev"></div>
      </div>
      `
      showLogos({
          title : 'Logos',
          html: newImages,
      }, async (result) => {
        if (result.isConfirmed) {
          const { message, success } = await saveSettings({
            data: {
              token,
              logoId,
            },
          });
          if (success) {
            showAlert({ message, icon: 'success' });
          } else {
            showAlert({ message, icon: 'error' });
          }
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info')
        }
      });
    });

    $(document).on('change', '.js-team-setting', async () => {
      const long_passes = $('#long_passes').val();
      const counter_attacks = $('#counter_attacks').val();
      const formation_id = $('#formation').val();
      const captain_nft_id = $('#captain').val();
      const freekick_nft_id = $('#freekick').val();
      const game_sense = $('#game_sense').val();

      const { message, success } = await saveSettings({
        data: {
          formation_id,
          captain_nft_id,
          freekick_nft_id,
          token,
          game_sense,
          counter_attacks,
          long_passes,
        },
      });
      if (success) {
        showAlert({ message, icon: 'success' });
      } else {
        showAlert({ message, icon: 'error' });
      }
    });

    let addNewPosition = '';
    let addNewNftId = '';
    let addNewGeneration = '';
    const showAddablePositions = ({ title, html, icon = 'success', option = {} }, callbak = () => {}) => {
      let options = {
        showCancelButton: false,
        confirmButtonText: 'Add',
        customClass: {
          cancelButton: 'order-1',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
        title,
        html,
        onOpen() {
          $(document).off('change.js-new-position').on('change.js-new-position', '.js-new-position', (e) => {
            e.preventDefault();
            addNewNftId = $('[name="new-position"]:checked').val();
            addNewGeneration = $(e.currentTarget).data('generation');
          });
          const swiper = new Swiper('.js-swiper-logos', {
            spaceBetween: 10,
            // allowTouchMove: false,
            slidesPerView: 2,
            navigation: {
              prevEl: $('.js-prev').get(0),
              nextEl: $('.js-next').get(0),
            },
            // navigation: {
            //   prevEl: $('.js-control-up'),
            //   nextEl: $('.js-control-down'),
            // },
            // freeMode: true,
            // freeModeSticky: true
          });
        },
      };

      options = Object.assign({}, options, option);

      Swal.fire(options).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        callbak(result)
      });

      // networkCheck();

      // $.post('/api/avatar/log', { m: message, e: 'a', mm: '0' });
    };

    $(document).on('click', '.js-add-team-player', async (e) => {
      addNewNftId = '';
      addNewPosition = $(e.currentTarget).data('position');
      addNewGeneration = $(e.currentTarget).data('generation');
      const freePlayers = await getFreePlayers({
        data: {
          token,
        },
      });

      // if (manager && freePlayers.players.length) {
      //   return false;
      // }

      $.fancybox.open(templateFreePlayer(freePlayers.players), {

      });
      /**
      showAddablePositions({
          title : 'Add Player',
          html: templateFreePlayer(freePlayers.players),
      }, async (result) => {
        if (result.isConfirmed && addNewNftId) {
          const { success, message, nft } = await addTeamPlayer({
            data: {
              sessionKey,
              nft_id: parseInt(addNewNftId),
              position: addNewPosition,
              generation: addNewGeneration,
            },
          });

          if (success) {
            const $targetElement = $(`.my-team__row-item[data-order_no=${nft.order_no}]`);

            $targetElement.attr('data-nft_id', nft.id);
            $targetElement.find('.my-team__player-bg img').attr('src', nft.image);
            $targetElement.find('span').text(nft.name);
            $targetElement.find('.js-remove-team-player').attr('data-nft_id', nft.id);

            showAlert({ message, icon: 'success' });

            render();
          } else {
            showAlert({ message, icon: 'error' });
          }
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info')
        } else {
          Swal.fire('Please select one player!', '', 'info')
        }
      });
       */
    });
    $(document).off('change.js-new-position').on('change.js-new-position', '.js-new-position', (e) => {
      addNewNftId = $('[name="new-position"]:checked').val();
      addNewGeneration = $(e.currentTarget).data('generation');
    });
    $(document).off('click.to-team-member').on('click.to-team-member', '.js-action-add-to-team-member', async () => {
      if (addNewNftId) {
        const { success, message, nft } = await addTeamPlayer({
          data: {
            token,
            nft_id: parseInt(addNewNftId),
            position: addNewPosition,
            generation: addNewGeneration,
          },
        });

        if (success) {
          const $targetElement = $(`.my-team__row-item[data-order_no=${nft.order_no}]`);

          $targetElement.attr('data-nft_id', nft.id);
          $targetElement.find('.my-team__player-bg img').attr('src', nft.image);
          $targetElement.find('span').text(nft.name);
          $targetElement.find('.js-remove-team-player').attr('data-nft_id', nft.id);

          showAlert({ message, icon: 'success' });
          render();
          $.fancybox.close();
        } else {
          showAlert({ message, icon: 'error' });
        }
      } else {
        Swal.fire('Please select one player!', '', 'info')
      }
    });
  });
};

export default myTeam;
